import React, { useState, useEffect } from "react";
import "../styles/Formularios.css";
import { useGlobal } from "../context/ContenedorGlobal";
import InputGenerico from "./InputGenerico";
import InputSelectEstados from "./InputSelectEstados";
import InputSelectSiNo from "./InputSelectSiNo";
import { useApiFetch } from "../utils/apiFetch";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../assets/logo_sict.png";
import InputNombrePuertoPp from "./InputNombrePuertoPp";
import InputNombrePuertoSw from "./InputNombrePuertoSw";


function ModificarPuertosSwitch() {

    const { setModuloActual, setSubModuloActual, elementoSeleccionado, setElementoSeleccionado, logout } = useGlobal();

    const [arrayPuertosSw, setArrayPuertosSw] = useState([]);
    const [nomTabla, setNomTabla] = useState(elementoSeleccionado.nom_switch);
    const [puertoSw, setPuertoSw] = useState("");
    const [idEstado, setIdEstado] = useState("");
    const [estado, setEstado] = useState("");
    const [voz, setVoz] = useState("");
    const [datos, setDatos] = useState("");
    const [puertoPp, setPuertoPp] = useState("");
    const [notasPsw, setNotasPsw] = useState("");
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const [puertoSeleccionado, setPuertoSeleccionado] = useState(null);
    const [mostrarFormulario, setMostrarFormulario] = useState(false);
    const apiFetch = useApiFetch();

    useEffect(() => {
        const fetchPuertos = async () => {
            setLoading(true);
            setError("");
            setSuccess("");

            try {
                if (elementoSeleccionado) {
                    const data = await apiFetch("consultar_puertos_sw.php?nom_switch=" + nomTabla, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" }
                    }, logout);

                    if (data.status === "ok") {
                        setArrayPuertosSw(data.data);
                        setSuccess("Lista de puertos del switch.");
                    } else {
                        setError(data.message || "Error al consultar los puertos.");
                        setTimeout(() => {
                            setModuloActual("Red");
                            setSubModuloActual(null);
                        }, 2000);
                    }
                }
            } catch (err) {
                setError("Error de conexión con el servidor: " + err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPuertos();
    }, []);

    // Se renderiza puertoSeleccionado con el nuevo valor
    const handleSelect = (pt) => {
        setPuertoSeleccionado(pt);
    }

    // Función para exportar uno o todos los puertos en csv
    const handleExportar = () => {
        let puertosParaExportar = [];

        if (puertoSeleccionado) {
            puertosParaExportar = [puertoSeleccionado];  // Se asigna el objeto "seleccionado" para exportar
        } else {
            puertosParaExportar = arrayPuertosSw;  // Se asigna todo el array de puertos al array de los puertos para exportar
        }

        // Definiendo los encabezados de las columnas para el archivo a exportar
        const headers = [
            "Puerto",
            "Estado",
            "Voz",
            "Datos",
            "Puerto PP"
        ];

        // Convertir a CSV
        const csvRows = [];
        csvRows.push(headers.join(",")); // La primera fila serán los encabezados

        puertosParaExportar.forEach(pt => {   // Las filas siguientes seran el o los puertos que esten en el array puertosParaExportar
            const row = [
                `"${pt.puerto_sw}"`,
                `"${pt.estado}"`,
                `"${pt.voz}"`,
                `"${pt.datos}"`,
                `"${pt.puerto_pp}"`
            ];
            csvRows.push(row.join(","));
        });

        const csvString = csvRows.join("\n");

        // Crear archivo descargable
        const BOM = "\uFEFF"; // Marca de Orden de Bytes para UTF-8
        const blob = new Blob([BOM + csvString], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "puertos.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    // Funcion para exportar en PDF
    const handleExportarPDF = () => {
        let puertosParaExportar = [];

        if (puertoSeleccionado) {
            puertosParaExportar = [puertoSeleccionado]; // solo el seleccionado
        } else {
            puertosParaExportar = arrayPuertosSw; // toda la lista
        }

        const doc = new jsPDF();

        // Logo institucional
        doc.addImage(logo, "PNG", 10, 10, 30, 15);

        // Encabezado
        doc.setFontSize(14);
        doc.text("Secretaría de Infraestructura, Comunicaciones y Transportes", 50, 20);
        doc.setFontSize(12);
        doc.text(`Listado de Puertos del Switch ${nomTabla}`, 50, 30);

        doc.setLineWidth(0.5);
        doc.line(10, 40, 200, 40);

        // Tabla
        autoTable(doc, {
            startY: 50,
            head: [["Puerto", "Estado", "Voz", "Datos", "Puerto PP"]],
            body: puertosParaExportar.map(pt => [
                pt.puerto_sw,
                pt.estado,
                pt.voz,
                pt.datos,
                pt.puerto_pp
            ])
        });

        // Pie de página
        doc.setFontSize(10);
        doc.text("© 2025-2026 SIGBI-712. Todos los derechos reservados.", 10, 290);

        // Nombre dinámico del archivo
        const nombreArchivo = puertoSeleccionado
            ? `puerto_${puertoSeleccionado.puerto_sw}.pdf`
            : `puertos_${nomTabla}.pdf`;

        doc.save(nombreArchivo);
    };

    // Función para desmarcar
    const handleDesmarcar = () => {
        setPuertoSeleccionado(null);
    };

    // Función para mostrar el formulario para modificar un puerto
    const handleModificar = () => {
        if (!puertoSeleccionado) {
            alert("Por favor selecciona un puerto para modificar.");
            return;
        }
        setMostrarFormulario(true);
    };


    const handleCancelar = () => {
        setMostrarFormulario(false);
        setPuertoSeleccionado(null);
    };

    // Efecto de sincronización de estado del puertoSeleccionado
    useEffect(() => {
        if (puertoSeleccionado) {
            setPuertoSw(puertoSeleccionado.puerto_sw || "");
            setIdEstado(puertoSeleccionado.id_estado || "");
            setVoz(puertoSeleccionado.voz || "");
            setDatos(puertoSeleccionado.datos || "");
            setPuertoPp(puertoSeleccionado.puerto_pp || "");
            setNotasPsw(puertoSeleccionado.notas_puerto_sw)
            setEstado(puertoSeleccionado.estado || "");
        }
    }, [puertoSeleccionado]);

    // Función handleSubmit para modificar el puerto
    const handleModificarPuerto = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        setSuccess("");

        try {

            const data = await apiFetch("modificar_puertos_sw.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    nom_switch: nomTabla,
                    puerto_sw: puertoSw,
                    id_estado: idEstado,
                    voz,
                    datos,
                    puerto_pp: puertoPp,
                    notas_puerto_sw: notasPsw
                })
            }, logout);

            if (data.status === "ok") {
                setSuccess("Puerto modificado correctamente.");
                setTimeout(() => {
                    setModuloActual("Red");
                    setSubModuloActual(null);
                }, 2000);
            } else {
                setError(data.message || "Error al modificar el puerto.");
            }
        } catch (err) {
            setError("Error de conexión con el servidor: " + err.message);
        } finally {
            setLoading(false);
        }
    };

    // Función para resetear los mensajes después de un tiempo
    useEffect(() => {
        if (error || success) {
            const timer = setTimeout(() => {
                setError("");
                setSuccess("");
            }, 2000);

            return () => clearTimeout(timer); // limpiar si cambia antes de los 2s
        }
    }, [error, success]);

    return (
        <div>
            {!mostrarFormulario ? (

                <div className="sesion-form">
                    {loading && <p>Cargando puertos...</p>}
                    {error && <p className="error">{error}</p>}
                    {success && <p className="success">{success}</p>}

                    {arrayPuertosSw.length > 0 && (
                        <table className="tabla-estandar seleccion-unica">
                            <thead>
                                <tr>
                                    <th>Seleccionar</th>
                                    <th>Puerto</th>
                                    <th>Estado</th>
                                    <th>Voz</th>
                                    <th>Datos</th>
                                    <th>Puerto PP</th>
                                </tr>
                            </thead>
                            <tbody>
                                {arrayPuertosSw.map((pt, index) => (
                                    <tr key={index}>
                                        <td data-label="Seleccionar">
                                            <input
                                                type="checkbox"
                                                checked={puertoSeleccionado?.puerto_sw === pt.puerto_sw}
                                                onChange={() => handleSelect(pt)}
                                            />
                                        </td>
                                        <td data-label="Puerto Switch">{pt.puerto_sw}</td>
                                        <td data-label="Estado">{pt.estado}</td>
                                        <td data-label="Voz">{pt.voz}</td>
                                        <td data-label="Datos">{pt.datos}</td>
                                        <td data-label="Perto Patch">{pt.puerto_pp}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    {arrayPuertosSw.length > 0 && (
                        <div className="form-buttons">
                            <button type="button" onClick={handleModificar} disabled={!puertoSeleccionado}>Modificar<br></br>puerto</button>
                            <button type="button" onClick={handleExportar}>Exportar<br></br>en CSV</button>
                            <button type="button" onClick={handleExportarPDF}>Exportar<br></br>en PDF</button>
                            <button type="button" onClick={handleDesmarcar} disabled={!puertoSeleccionado}>Desmarcar</button>
                        </div>
                    )}

                </div>

            ) : (

                <div className="sesion-form">

                    {success && <div className="success">Datos del puerto moficicados correctamente</div>}
                    {error && <div className="error">{error}</div>}

                    <form onSubmit={handleModificarPuerto}>

                        <InputNombrePuertoSw
                            value={puertoSw}
                            setValue={setPuertoSw}
                            label="Nombre del puerto switch"
                            title="Formato: sw1_ep_p1_10, máximo 12 caracteres."
                            readOnly={true}
                        />

                        <InputSelectEstados
                            idEstado={idEstado}
                            setIdEstado={setIdEstado}
                            estadoActualText={estado}
                            idEntidad={5}
                            label="Estado del puerto"
                            apiUrl={`consultar_estados.php`}
                        />

                        <InputSelectSiNo
                            value={voz}
                            setValue={setVoz}
                            label="Voz"
                        />

                        <InputSelectSiNo
                            value={datos}
                            setValue={setDatos}
                            label="Datos"
                        />

                        <InputNombrePuertoPp
                            value={puertoPp}
                            setValue={setPuertoPp}
                            label="Nombre del puerto patch panel"
                            placeholder="pp1_ep_p1_10"
                            title="Formato: pp1_ep_p1_10, máximo 12 caracteres."
                        />

                        <InputGenerico
                            value={notasPsw}
                            setValue={setNotasPsw}
                            label="Notas del puerto"
                            readOnly={false}
                            allowedChars="a-pA-Z0-9ñÑáéíóúÁÉÍÓÚ_\- .,/"
                            maxLength={255}
                            placeholder="Escriba su texto aquí"
                            title="Máximo 255 caracteres"
                        />

                        <div className="form-buttons">
                            <button type="submit">Modificar</button>
                            <button type="botton" onClick={handleCancelar} >Cancelar</button>
                        </div>
                    </form>

                </div>

            )}
        </div>
    );
}

export default ModificarPuertosSwitch;